import React, {useRef, useState} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {getToken} from '@app/utils/helper';

const InputFilePDFDoc = ({onChange, uploadUrl}) => {
    const token = getToken();
    const [file, setFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const inputRef = useRef();

    const handleInputChange = async (event) => {
        const selectedFile = event.target.files[0];

        if (
            selectedFile &&
            (selectedFile.type === 'application/pdf' ||
                selectedFile.type === 'application/msword' ||
                selectedFile.type ===
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document')
        ) {
            setFile(selectedFile);

            if (uploadUrl) {
                setUploading(true);
                const formData = new FormData();
                formData.append('file', selectedFile);

                try {
                    const response = await axios.post(uploadUrl, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            Authorization: `bearer ${token}`
                        },
                    });
                    console.log(response);
                    const savedFileName = response.data.$values[0].filePath;
                    setUploading(false);
                    onChange({savedFileName});
                } catch (error) {
                    console.error('Error uploading file:', error);
                    if (error.response) {
                        console.error('Response error:', error.response.data);
                    }
                    setUploading(false);
                    alert('Tải tệp lên thất bại, vui lòng thử lại.');
                    setFile(null);
                }
            } else {
                onChange(selectedFile);
            }
        } else {
            alert('Vui lòng chọn tệp có định dạng PDF, DOC, hoặc DOCX');
            setFile(null);
        }

        event.target.value = '';
    };

    const handleClick = () => {
        inputRef.current.click();
    };

    return (
        <div>
            <button
                type="button"
                className="btn btn-primary"
                onClick={handleClick}
                disabled={uploading}
            >
                {uploading ? 'Đang tải lên...' : 'Chọn tệp PDF, DOC, hoặc DOCX'}
            </button>
            <input
                ref={inputRef}
                type="file"
                accept=".pdf,.doc,.docx"
                style={{display: 'none'}}
                onChange={handleInputChange}
            />

            {file && !uploading && (
                <div className="mt-2">
                    <strong>Đã chọn:</strong> {file.name}
                </div>
            )}
        </div>
    );
};

InputFilePDFDoc.propTypes = {
    onChange: PropTypes.func.isRequired,
    uploadUrl: PropTypes.string
};

export default InputFilePDFDoc;
